/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RttrSerialVerifyResponse
 */
export interface RttrSerialVerifyResponse {
    /**
     * False when Minelab's HubSpot has no registration for this serial — the response carries no points/product fields and the frontend renders a "have you registered the product?" CTA. True for a successful credit; the points/product fields are populated.
     * @type {boolean}
     * @memberof RttrSerialVerifyResponse
     */
    matched: boolean;
    /**
     * 
     * @type {number}
     * @memberof RttrSerialVerifyResponse
     */
    pointsAwarded?: number;
    /**
     * 
     * @type {string}
     * @memberof RttrSerialVerifyResponse
     */
    productName?: string;
    /**
     * 
     * @type {number}
     * @memberof RttrSerialVerifyResponse
     */
    productTier?: number;
    /**
     * True when the registration predates campaign start (existing-product credit), false for post-launch purchases.
     * @type {boolean}
     * @memberof RttrSerialVerifyResponse
     */
    isExisting?: boolean;
}

/**
 * Check if a given object implements the RttrSerialVerifyResponse interface.
 */
export function instanceOfRttrSerialVerifyResponse(value: object): value is RttrSerialVerifyResponse {
    if (!('matched' in value) || value['matched'] === undefined) return false;
    return true;
}

export function RttrSerialVerifyResponseFromJSON(json: any): RttrSerialVerifyResponse {
    return RttrSerialVerifyResponseFromJSONTyped(json, false);
}

export function RttrSerialVerifyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RttrSerialVerifyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'matched': json['matched'],
        'pointsAwarded': json['pointsAwarded'] == null ? undefined : json['pointsAwarded'],
        'productName': json['productName'] == null ? undefined : json['productName'],
        'productTier': json['productTier'] == null ? undefined : json['productTier'],
        'isExisting': json['isExisting'] == null ? undefined : json['isExisting'],
    };
}

export function RttrSerialVerifyResponseToJSON(json: any): RttrSerialVerifyResponse {
    return RttrSerialVerifyResponseToJSONTyped(json, false);
}

export function RttrSerialVerifyResponseToJSONTyped(value?: RttrSerialVerifyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matched': value['matched'],
        'pointsAwarded': value['pointsAwarded'],
        'productName': value['productName'],
        'productTier': value['productTier'],
        'isExisting': value['isExisting'],
    };
}

